<div class="d-flex gap-3">
  <div class="container-box shadow-none flex-fill">
    <div class="d-flex gap-3 align-items-center p-3">
      <img src="/assets/images/channel-wizards/step-icon1.webp" alt="" height="40" />
      <div>
        <h6 class="mb-0" i18n>Preparation</h6>
        <div class="text-sm">
          <ng-container i18n>This section will prepare you for connecting Trip.com with AdvanceCM.</ng-container> <br />
          <ng-container i18n>Please read through these instructions carefully before proceeding.</ng-container>
        </div>
      </div>
    </div>
    <div class="border-top p-4">
      <div>
        <mat-accordion>
          <mat-expansion-panel [expanded]="true" #start>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">1</div>
                <ng-container i18n>Create or Import Rentals</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <div class="text-semi-bold" i18n>To connect your AdvanceCM rental to Trip.com, follow these steps:</div>
              <ul class="pl-3 lh-lg">
                <li i18n>Ensure you have manually created or imported a rental from Airbnb before proceeding.</li>
                <li i18n>
                  If you use both Airbnb and Trip.com, connect to Airbnb first to have rentals imported to AdvanceCM..
                </li>
                <li>
                  <ng-container i18n>Follow this</ng-container>
                  <a target="_blank" href="https://help.tokeet.com/rental-settings/how-do-i-add-and-update-rentals" i18n
                    >guide</a
                  >
                  <ng-container i18n>for detailed instructions.</ng-container>
                </li>
                <li i18n>
                  One AdvanceCM rental can connect to multiple channels. Combined availability from all channels will be
                  synced and pushed out.
                </li>
              </ul>
              <div class="text-right">
                <button class="btn btn-light-info" (click)="blocked.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #blocked>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">2</div>
                <ng-container i18n>Blocked Dates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p i18n>
                After connecting AdvanceCM with Trip.com your availability will be determined solely by what shows on
                your AdvanceCM rental calendar.
              </p>

              <div class="alert alert-secondary-warning2 align-items-start">
                <i class="cs-icon cs-icon-alert-triangle2 alert-icon"></i>
                <div class="alert-content">
                  <div class="text-semi-bold" i18n>Important Notes</div>
                  <ul class="pl-3">
                    <li i18n>
                      Replicate any manual hold events from your channels onto the AdvanceCM calendar to keep dates
                      blocked. Hold events set on Trip.com are not imported.
                    </li>
                    <li>
                      <ng-container i18n>For detailed instructions, please refer to this</ng-container>
                      <a target="_blank" href="https://help.tokeet.com/calendars/what-is-a-hold-event" i18n>guide</a>
                      <ng-container i18n>on how to add a hold event.</ng-container>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="text-right">
                <button class="btn btn-light-info" (click)="prepare.open()">
                  <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
                </button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel #prepare>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="step-number mr-2">3</div>
                <ng-container i18n>Preparing Rates</ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p i18n>
                Moving forward, you must push rates from AdvanceCM to Trip.com, as direct edits on the Trip.com rates
                calendar will not be possible.
              </p>

              <div class="text-smi-bold" i18n>Pushing Rates</div>
              <ul class="pl-3 lh-lg">
                <li i18n>Pushing rates to Trip.com is a required step in the connection wizard.</li>
                <li>
                  <ng-container i18n>Prepare your rates using this</ng-container>
                  <a target="_blank" href="https://help.tokeet.com/rates-management/rates-overview" i18n>guide</a>
                  <ng-container i18n>before beginning.</ng-container>
                </li>
              </ul>
              <div class="text-smi-bold" i18n>Creating Rates</div>
              <ul class="pl-3 lh-lg">
                <li i18n>
                  You can create a rate within the connection wizard and make changes after the connection is complete.
                </li>
                <li i18n>
                  If you have a straightforward plan (e.g., one standard rate), adding the rate within the connection
                  wizard is recommended.
                </li>
              </ul>
              <div class="text-smi-bold" i18n>Additional Guest Fees</div>
              <ul class="pl-3 lh-lg">
                <li i18n>Ensure your Trip.com rates are set to accept additional guest fees if applicable.</li>
                <li i18n>Finalize your rate plans on Trip.com.</li>
              </ul>
              <div class="alert alert-secondary-warning2 align-items-start">
                <img
                  src="/assets/images/integrations/rategenie.png"
                  alt="Rategenie"
                  class="alert-icon"
                  style="height: 1.5rem"
                />
                <div class="alert-content">
                  <b class="text-nowrap" i18n>Recommended Tool:</b>
                  <ng-container i18n>We highly recommend using</ng-container>
                  <a href="https://www.rategenie.io/" target="_blank">Rategenie</a>
                  <ng-container i18n
                    >for rental rate management, as it is the most advanced dynamic pricing application in the
                    industry.</ng-container
                  >
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-5 d-flex align-items-center justify-content-between">
        <button class="btn btn-outline-light" (click)="prev.emit()">
          <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
          <ng-container i18n>Previous</ng-container>
        </button>
        <button class="btn btn-secondary-info" (click)="next.emit()">
          <ng-container i18n>Next</ng-container>
          <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="channel-wizard-right-wrapper rounded px-4">
    <img src="/assets/images/channel-wizards/step2.webp" alt="" class="w-100" />
  </div>
</div>
